/// <reference path="../../../../../../typings/index.d.ts" />
/// <reference path="../meevomessenger.component.base.ts" />

module Meevo.Plugins.MeevoMessenger {
    class ClientAppController extends MessengerComponentBase {
        static $inject = [
            "$mdSidenav",
            "meevo.AppSettings",
            "meevo.components.common.BusinessInfoDataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.busy.BusyService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            "meevo.components.short-cuts.ShortCutsService",
            "$filter",
            "$translate",
            "$q",
            "meevo.plugins.meevoMessenger.meevoMessengerService",
            "meevo.plugins.meevoMessenger.meevoMessengerApiService",
            "$timeout",
            "meevo.components.common.SecurityService",
        ];

        public poweredByEntityName: string = 'MeGo';

        //initialize base class variables
        intialSettingsSectionName = 'SECTION_ME_GO';
        undeleteConversationType = null;
        messageLengthLimit = Meevo.Plugins.MeevoMessenger.Constants.MESSAGE_LENGTH_LIMIT;

        constructor( 
            protected $mdSidenav: ng.material.ISidenavService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: any,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected $filter: angular.IFilterService,
            protected $translate: angular.translate.ITranslateService,
            protected $q: angular.IQService,
            protected meevoMessengerService: IMeevoMessengerService,
            protected meevoMessengerApiService: IMeevoMessengerApiService,
            protected $timeout: angular.ITimeoutService,
            protected securityChecker: Meevo.Components.Common.ISecurityService
        ) {
            super(
                $mdSidenav,
                appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                busyService,
                $rootScope,
                $scope,
                $state,
                contextParams,
                shortCutsService,
                $filter,
                $translate,
                $q,
                meevoMessengerService,
                meevoMessengerApiService,
                $timeout,
                MeevoMessengerClassificationAPI.MEGO,
                securityChecker
            );

            this.notificationClassification = 'MEGO';
        }

        initEventHandler(params) {
            // Call parent implementation first to keep existing subscriptions
            super.initEventHandler(params);

            // Add MeGo specific subscription
            this.$scope.$on(MeevoMessengerMessages.REFRESH_CLIENT_APP_CONVERSATION, () => {
                if (this.meevoMessengerSettings) {
                    this.openConversations(true);
                }
            });
        }

        getOptOutStatus(): any { }

        mapUserInformationToTheConversationWindow(isClient: boolean, userInformation): void {
            const existingConversation: MeevoMessengerConversation = this.meevoMessengerService.findConversation(this.conversationPreviewList, { clientId: userInformation.id });

            if (!existingConversation) {
                // For MeGo business cannot initiate a conversation by sending a message to a client
                return;
            }

            if (isClient === this.isClientMessaging) {
                existingConversation.contactFirstName = userInformation.firstName;
                existingConversation.contactLastName = userInformation.lastName;
                existingConversation.displayName = userInformation.displayName;
                existingConversation.meevoFile = userInformation.meevoFile;

                if (isClient) {
                    existingConversation.clientId = userInformation.id;
                } else {
                    existingConversation.employeeId = userInformation.id;
                }
            }

            this.updateConversation(existingConversation).then((conversation: MeevoMessengerConversation) => {
                if (!conversation) return;

                _.assign(existingConversation, conversation);
                this.loadConversation(conversation.id);
            });
        }
        get defaultConversationBodyRequest(): Record<string, any> {
            return {
                classification: this.classification,
                pageNumber: 0,
                itemsPerPage: 9999
            }
        }

        get isOutOfDateLastInboundMessage(): boolean {
            const lastMessageDateCreated = this.selectedConversation.lastMessage.createdDateTime;
            const twoWeeksAgo = new Date().setDate(new Date().getDate() - 15); // 2 weeks doesn't include 14's day

            return !(new Date(twoWeeksAgo) < new Date(lastMessageDateCreated)) && this.selectedConversation.lastMessage.isInbound
        }

        get isDisabledMessagingForm(): boolean {
            const isSelectedUserWithPhone = !!(this.selectedUser && ((<Meevo.Model.Employee>this.selectedUser).phoneNumber || (<Meevo.Model.ClientListItem>this.selectedUser).primaryPhoneNumber));
            const isSetRecipient = isSelectedUserWithPhone || this.selectedPhoneNumber || this.selectedConversation;
            return !this.isMeevoMessengerClientAppInitialized || !isSetRecipient || this.isOutOfDateLastInboundMessage;
        }
        get isMeevoMessengerClientAppInitialized(): boolean {
            return this.meevoMessengerSettings && !!(this.meevoMessengerSettings.locationId) && !!(this.meevoMessengerSettings.tenantId);
        }
        get newConversations() {
            return this.$state['current'].params.newConversations;
        }
    }

    class ClientAppComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/meevoMessenger/components/clientApp/index.html';
        controller = ClientAppController;
        controllerAs = 'meevoMessenger';
        bindings: any = {
            isAccountInitialized: '=',
            isAutoReplyEnabled: '=',
            sideNavClientInfo: '=',
            isPulsing: '='
        };
    }

    angular.module('meevo.plugins.meevoMessenger')
        .component('clientAppComponent', new ClientAppComponent());

}
